'use client'
import*as l from"@radix-ui/react-collapsible";var i=l.Root,e=l.CollapsibleTrigger,o=l.CollapsibleContent;export{i as a,e as b,o as c};
